import React from 'react';
import Icon from '../../../components/AppIcon';

const CommissionSummary = ({ summary }) => {
  const summaryCards = [
    {
      title: 'Total gagné',
      value: `${summary?.totalEarned?.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €`,
      icon: 'Euro',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+12,5%',
      changeType: 'positive'
    },
    {
      title: 'Commissions en attente',
      value: `${summary?.pendingCommissions?.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €`,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      change: '+8,2%',
      changeType: 'positive'
    },
    {
      title: 'Paiement suivant',
      value: summary?.nextPaymentDate,
      icon: 'Calendar',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      change: '5 jours',
      changeType: 'neutral'
    },
    {
      title: 'Seuil minimum',
      value: `${summary?.minimumThreshold?.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €`,
      icon: 'Target',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted',
      change: summary?.thresholdProgress,
      changeType: 'neutral'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {summaryCards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${card?.bgColor}`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
            <div className={`text-sm font-medium ${
              card?.changeType === 'positive' ? 'text-success' : 
              card?.changeType === 'negative' ? 'text-error' : 'text-muted-foreground'
            }`}>
              {card?.change}
            </div>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">{card?.title}</p>
            <p className="text-2xl font-bold text-card-foreground">{card?.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommissionSummary;